import _ from 'lodash'
import { getHours, getMinutes } from 'date-fns'

const isOfflineMode = _.get(window, ['_env_', 'IS_OFFLINE_MODE'], 'true')

function getOfflineModeState() {
  return isOfflineMode === 'true'
}

function constructBackendUrl() {
  const urlFromBrowser = window.location.href
  const [partialScheme, , authority] = urlFromBrowser.split('/')
  const [scheme] = partialScheme.split(':')
  const [domainName] = authority.split(':')
  const port = _.get(window, ['_env_', `BACKEND_PORT_${_.toUpper(scheme)}`])

  return `${scheme}://${domainName}:${port}`
}

function replaceHostName(url) {
  const authorityRegex = /^https?:\/\/[a-z0-9A-Z.\-:]+/
  const backendUrl = constructBackendUrl()
  try {
    return url.replace(authorityRegex, backendUrl)
  } catch (e) {
    return ''
  }
}

function replaceProtocol(url) {
  const newUrl = new URL(url)
  newUrl.protocol = newUrl.protocol.replace('http', 'ws')
  return newUrl.href
}

function getMwlState() {
  return _.get(window, ['_env_', 'IS_MWL_ENABLED']) === 'true'
}

function getHourAndMinute(date) {
  const hour = getHours(date)
  const hourAsString = hour.toString()
  const formattedHour = hourAsString.length === 2 ? hourAsString : `0${hour}`

  const minute = getMinutes(date)
  const minuteAsString = minute.toString()
  const formattedMinute =
    minuteAsString.length === 2 ? minuteAsString : `0${minute}`

  return `${formattedHour}${formattedMinute}00`
}

export default {
  getOfflineModeState,
  constructBackendUrl,
  replaceHostName,
  replaceProtocol,
  getMwlState,
  getHourAndMinute
}
